import {
    ref
} from 'vue';

let json = sessionStorage.getItem('user') || null;
let saved_user = null
if(json){
    saved_user = JSON.parse(json);
}
export const user = ref(saved_user);